import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea59f418"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-account px-10" }
const _hoisted_2 = { class: "create-account__wrapper text-center pa-40" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-20" }, [
  /*#__PURE__*/_createTextVNode("Получи доступ"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" к личному кабинету")
], -1))
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"text-gradient d-inline-flex flex-direction-column\" data-v-ea59f418><h6 class=\"text-center mb-10\" data-v-ea59f418>Стань соавтором</h6><h6 class=\"text-center mb-10\" data-v-ea59f418>Влияй на контент на платформе</h6><h6 class=\"text-center mb-10\" data-v-ea59f418>Получай баллы и призы</h6><h6 class=\"text-center mb-10\" data-v-ea59f418>Получи доступ к бекстейдж видео</h6></div>", 1)

import BaseButton from '@/components/Buttons/BaseButton.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateAccount',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_router_link, { to: {name: 'login-register'} }, {
        default: _withCtx(() => [
          _createVNode(BaseButton, {
            class: "large rounded margin-auto mb-20",
            bg: "gradient",
            border: "gradient"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Создать аккаунт")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_4
    ])
  ]))
}
}

})